import { Controller } from "@hotwired/stimulus"
import { showConfirmModal, confirmSkipped } from "../lib/confirm_modal.mjs"

// Puts a confirmation in front of a link or submit button:
//   data-controller="confirm-modal" data-action="click->confirm-modal#handleClick"
//   data-confirm-prompt="Really void this invoice?"
// The dialog itself is the singleton in shared/_confirm_modal.html.erb; see lib/confirm_modal.mjs.
export default class extends Controller {
  static values = {
    prompt: String,
    allowSkip: { type: Boolean, default: true },
    confirmKey: String
  }

  // Called when a button/link with this controller is clicked
  async handleClick(event) {
    event.preventDefault()
    event.stopPropagation()

    const element = event.currentTarget
    const prompt = element.dataset.confirmPrompt || this.promptValue || "Are you sure?"
    const allowSkip = element.dataset.confirmAllowSkip !== "false"
    const confirmKey = this.confirmKeyFor(element)

    // Check if user previously selected "don't ask again"
    if (confirmSkipped(confirmKey)) {
      this.proceedWithAction(element)
      return
    }

    const confirmed = await showConfirmModal({ message: prompt, allowSkip, confirmKey })

    if (confirmed) {
      this.proceedWithAction(element)
    }
  }

  confirmKeyFor(element) {
    if (element.dataset.confirmKey) return element.dataset.confirmKey
    if (element.href) return element.href
    if (element.form) return element.form.action

    return window.location.pathname
  }

  proceedWithAction(element) {
    if (element.form) {
      // It's a submit button - submit the form
      element.form.requestSubmit(element)
    } else if (element.href) {
      // It's a link - navigate to it
      window.location.href = element.href
    }
  }
}
